module.exports = __webpack_public_path__ + "static/img/02.2400685.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/buyer/02.jpeg
// module id = qUfd
// module chunks = 0